import { MessageMedium } from 'modules/graphql';
import { colors } from 'ui/theme';
import { getMediumIcon } from 'utils/messageMediums';

export const MediumIcon = ({ messageMedium }: { messageMedium: MessageMedium }) => {
  const Icon = getMediumIcon(messageMedium);
  return <Icon color={colors.grey35} />;
};
